module.exports = __webpack_public_path__ + "static/media/guide.7a6639d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/guide.png
// module id = 746
// module chunks = 0